import React from "react"
import { useIntl } from "react-intl"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { NavItemWrapper } from "./MainNavigation"
import { UnreadMessagesDot } from "./UnreadMessagesDot"

export function MessagesNavItem({ onClick }: { onClick: () => void }): JSX.Element {
  const intl = useIntl()
  const { data: programFlags } = useMemberProgramFlags()

  return (
    <NavItemWrapper
      link="/messages"
      onClick={onClick}
      text={intl.formatMessage({ defaultMessage: "Messages" })}
      // ONE DOT, whichever source lit it — /messages is one page for everyone now, so the indicator on
      // the way to it is one indicator. `showProviderUnread` is the only fork left: a member with no
      // Providers tab has their provider unread state left unconsulted entirely.
      //
      // Unlike the route there is no loading gate on the flags. Falling back to carrot-only while they
      // resolve costs nothing and cannot flash — the dot renders nothing until a thread list loads
      // either way.
      extraNavIndicator={<UnreadMessagesDot showProviderUnread={programFlags?.isConsumer === true} />}
    />
  )
}
